export const moreSvg = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" aria-labelledby="title" width={20} height={20}
                                  aria-describedby="desc" role="img">
    <title>More</title>
    <desc>A line styled icon from Orion Icon Library.</desc>
    <circle data-name="layer3"
            cx="8" cy="32" r="6" fill="none" stroke="#202020" stroke-miterlimit="10"
            stroke-width="4" stroke-linejoin="round" stroke-linecap="round"></circle>
    <circle data-name="layer2" cx="56" cy="32" r="6" fill="none"
            stroke="#202020" stroke-miterlimit="10" stroke-width="4" stroke-linejoin="round"
            stroke-linecap="round"></circle>
    <circle data-name="layer1" cx="32" cy="32" r="6" fill="none"
            stroke="#202020" stroke-miterlimit="10" stroke-width="4" stroke-linejoin="round"
            stroke-linecap="round"></circle>
</svg>